import * as Yup from "yup";

export type SearchMode = "email" | "name";
export type AccountRecoveryRole = "director" | "coach" | "student";

export const ROLE_OPTIONS: {
  label: string;
  value: AccountRecoveryRole;
}[] = [
  { label: "Director", value: "director" },
  { label: "Coach", value: "coach" },
  { label: "Learner", value: "student" },
];

export const initialValues = {
  searchMode: "email" as SearchMode,
  email: "",
  firstName: "",
  lastName: "",
  role: "" as AccountRecoveryRole | "",
};

export const getValidationSchema = () =>
  Yup.object().shape({
    searchMode: Yup.string().oneOf(["email", "name"]).required(),
    email: Yup.string().when("searchMode", {
      is: "email",
      then: (schema) =>
        schema
          .email("Please enter a valid email address")
          .required("Email is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    firstName: Yup.string().when("searchMode", {
      is: "name",
      then: (schema) => schema.required("First name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    lastName: Yup.string().when("searchMode", {
      is: "name",
      then: (schema) => schema.required("Last name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    role: Yup.string().when("searchMode", {
      is: "name",
      then: (schema) =>
        schema
          .oneOf(["director", "coach", "student"], "Please select a role")
          .required("Please select a role"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
